import * as React from 'react'
import { FormattedDateTime } from 'components/formatted-datetime'
import { FeedbackItemCreatedNotification } from '../../../../store/modules/notifications'

export type FeedbackReceivedContentProps = {
  notification: FeedbackItemCreatedNotification
}

export const FeedbackReceivedContent: React.VFC<
  FeedbackReceivedContentProps
> = (props) => {
  const { notification } = props

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        <strong className="font-bold">
          {notification.author ? notification.author.fullName : 'Someone'}
        </strong>{' '}
        has given you some feedback.
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">View and add skills</span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
